<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 40]
      }
    },
    layout: {
      type: String,
      default: 'sizes, prev, pager, next'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: 1, limit: val }, 'pageSize')     //因为后台接口currentPage是从0开始的
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize }, 'pageNo')
    }
  }
}
</script>

<style scoped>
  .pagination-container {
    text-align: left;
    background: #fff;
    /* padding: 32px 16px; */
    box-sizing: border-box;
    margin-top: 9px;
    /* padding: 10px 0; */
  }
  .pagination-container.hidden {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/commonCom/pagination.vue